import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPatch } from "../client";
import type { Availability, Creator, Role } from "../types";
import { createOptimisticHandlers } from "./optimistic";
import { qk } from "./qk";

export const meQuery = () =>
  queryOptions({
    queryKey: qk.me(),
    queryFn: () => apiGet<Creator>("/api/me"),
    staleTime: Infinity, // plan §5: me/cart only change via mutations
  });

export interface UpdateProfileVariables {
  displayName?: string;
  bio?: string;
  skills?: string[];
  location?: string;
  availability?: Availability;
  role?: Role;
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables: UpdateProfileVariables) => apiPatch<Creator>("/api/me", variables),
    ...createOptimisticHandlers<UpdateProfileVariables>({
      queryClient,
      action: "update-profile",
      affectedKeys: () => [qk.me()],
      apply: (variables) => [
        {
          queryKey: qk.me(),
          updater: (previous) => (previous ? { ...(previous as Creator), ...variables } : (previous as Creator)),
        },
      ],
    }),
  });
}
